import { h } from "preact";
import './notify.scss';
import { Link } from "react-router-dom";

export let Notify = ({ notifs, onClear }: any) => notifs.length ?
    <div className="notify">
        {notifs.map((notif: any) =>
            <div key={notif.id} className={notif.type.toLowerCase()}>
                <div className="notification-warning">
                    <p className="no-margin-y m-l-half">
                        <span dangerouslySetInnerHTML={{ __html: notif.message }} />&nbsp; 
                        {notif.action && (
                            notif.route === '/encuesta' ? (
                                <a href={`https://es.surveymonkey.com/r/8FKCRH9`} target="_blank"><b>{notif.action}</b></a>
                            ) : (
                                <Link to={notif.route}><b>{notif.action}</b></Link>
                            )
                        )}
                    </p>
                </div>
            </div>
        )}
    </div> : null;